import { makeAutoObservable } from "mobx";

interface ProjectDetails {
  projectName: string;
  description?: string;
}

class ProjectNameStore {
  projectDetails: ProjectDetails = {
    projectName: "",
    description: ""
  };

  constructor() {
    makeAutoObservable(this);
  }

  setProjectDetails(details: ProjectDetails) {
    this.projectDetails = { ...this.projectDetails, ...details };

    console.log(this.projectDetails)
  }

  resetForm() {
    this.projectDetails = {
      projectName: "",
      description: ""
    };
  }
  get getProjectDetails() {
    return this.projectDetails;
  }
}

const projectNameStore = new ProjectNameStore();
export default projectNameStore;
